import { gql } from '@apollo/client';

export const ExperienceFields = gql`
  fragment ExperienceFields on Experience {
    id
    comment
    description
    requestedPrice
    hashtags {
      id
      name
    }
    status
    storeId
    title
    createdAt
    deletedAt
    numberOfUnits
    price
    slug
    store {
      id
      firstName
      lastName
      slug
      role
      storeDetails {
        id
        storeName
        avatarURL
      }
    }
    images {
      id
      isMainImage
      experienceId
      experienceImageFileKey
    }
  }
`;

export const ExperienceRequestFields = gql`
  fragment ExperienceRequestFields on ExperienceRequest {
    createdAt
    customer {
      id
      lastName
      firstName
    }
    customerId
    declineReason
    email
    earning
    experience {
      id
      comment
      description
      requestedPrice
      status
      title
      createdAt
      deletedAt
      numberOfUnits
      price
      slug
      images {
        id
        isMainImage
        experienceId
        experienceImageFileKey
      }
    }
    store {
      id
      slug
      role
      storeDetails {
        id
        storeName
        avatarURL
      }
    }
    experienceId
    id
    paidAt
    paymentMethodId
    price
    quantity
    requestStatus
    requestedPrice
    stripeIntentClientSecret
    stripeIntentID
    title
    phoneNumber
    discountAmount
    paymentMethod {
      type
    }
  }
`;
